import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController, AlertController, IonInput, NavParams, LoadingController } from '@ionic/angular';
import { CartService } from '../../services/cart.service';
import { Decimal } from 'decimal.js';
import { StorageService } from 'src/app/services/storage.service';
import { CustomPaymentServiceService } from "src/app/services/custom-payment-service.service";

@Component({
    selector: 'app-checkout-payment-custom-payment-service',
    templateUrl: './checkout-payment-custom-payment-service.page.html',
    styleUrls: ['./checkout-payment-custom-payment-service.page.scss'],
})
export class CheckoutPaymentCustomPaymentServicePage implements OnInit {

    @ViewChild('payment_amount_input', { static: false }) payment_amount_input: IonInput;

    spinner = null;
    custom_payment_service_id = null;
    custom_payment_service = null;
    payment_service_transaction_id = null;
    cart = null;
    payment = {
        method: 'custom',
        price: null,
        label:'Payment service'
    };
    payment_amount = null;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private cartService: CartService,
        private storageService: StorageService,
        public navParams: NavParams,
        private customPaymentServiceService: CustomPaymentServiceService,
        public loadingController: LoadingController,
    ) { }

    ngOnInit() {

        if(this.navParams.get("custom_payment_service_id")) {

            this.custom_payment_service_id = this.navParams.get("custom_payment_service_id");

            this.loadData().then(() => {
                this.cartService.get().then((cart) => {
                    if(cart) {
                        this.cart = cart;
                        this.payment_amount = this.cart.amount_due.toFixed(2);
                        this.payment.price = this.cart.amount_due;
                    }
                })                
            })
            .catch(() => { });

        }

    }

    loadData() {
        return new Promise<void>((resolve, reject) => {
            this.presentSpinner("Loading custom payment service").then(() => {
                this.customPaymentServiceService.getCustomPaymentService(this.custom_payment_service_id).then((custom_payment_service) => {
                    if(custom_payment_service) {
                        this.custom_payment_service = custom_payment_service;
                        this.spinner.dismiss();
                        resolve();
                    }
                })
                .catch(() => {
                    this.spinner.dismiss();
                    reject();
                });
            });
        });
    }

    ionViewDidEnter() {
        // NOTE: we use a timeout here so the DOM gets a chance to load
        setTimeout(() => {
            if(this.payment_amount_input) {
                this.payment_amount_input.setFocus();
            }
        }, 200);
    }

    sanitisePaymentAmount() {

        let payment_amount = this.payment_amount.toString();
        
        // only accept numbers/decimal points
        if(/[^0-9.]/.test(payment_amount)) {
            this.payment.price = null;
        }        
        else if(payment_amount.startsWith('.')) {
            this.payment.price = null;
        }
        else if(payment_amount.endsWith('.')) {
            this.payment.price = null;
        }              
        else if(payment_amount.split('.').length > 2) {
            this.payment.price = null;
        }
        else if(!payment_amount.length) {
            this.payment.price = null;
        }
        else {
            this.payment.price = Number(new Decimal(payment_amount).toDecimalPlaces(2));
        }

    }

    addPayment() {

        // ensure payment isn't over the amount due
        if(this.payment.price > this.cart.amount_due) {
            this.payment.price = this.cart.amount_due;
        }

        this.payment['payment_service_id'] = this.custom_payment_service_id;
        this.payment['label'] = this.custom_payment_service.name;

        if(this.payment_service_transaction_id) {
            this.payment['payment_service_transaction_id'] = this.payment_service_transaction_id;
        }

        this.cartService.addPayment(this.payment).then(() => {
            this.modalController.dismiss();
        });
    
    }

    close() {
        this.modalController.dismiss();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

}
